<template>
  <div class="rounded-t-xxl bg-white bg-cover" :style="makeStyles(hasKiosk && mainSectionTopRadius , mainSubCategorysBackground)">
    <!-- category box -->
    <Category
      class="block md:hidden"
      ref="Category"
      @category-changed="categoryChanged"
    />
    <!-- items category -->
    <div :class="!menu.is_kiosk_horiz_categ&&'flex'">
      <!-- <div
        class="md:block hidden"
        v-if="menu.is_kiosk_horiz_categ"
      >
        <TopNavigation />
      </div> -->

      <div  class="md:block hidden">
        <TopNavigation
          v-if="!isThemeLoading"
          ref="TopNavigation"
          @category-changed="categoryChanged"
          :infiniteScroll="infiniteScroll"
          :desktopMode="
            userAgent.device.type === 'desktop'
          "
        />
      </div>

      <!-- overflow-y-auto heighttest -->
      <div class="md:w-full md:flex md:justify-center">
        <div
          :class="['md:flex md:w-11/12 h-screen',
          menu.layout == 'frydate' ? 'md:w-full' : '',
          !menu.is_kiosk_horiz_categ && menu.desktop_kiosk_left_bar? 'mt-8' : '',
          isSearchKiosk ? 'flex-col' : '',
        ]"
          ref="categoryScrollableDiv"
          :style="`height:calc(100vh - ${restaurantHeaderHeight}px)`"
          @scroll="handleScroll"        
        >
        <!-- For Frydate it was required to not scroll the sidebar but only the content so the classes are applied -->
          <div v-show="!(menu.desktop_kiosk_left_bar || menu.is_kiosk_horiz_categ)" :class="[!menu.is_kiosk_horiz_categ && !isMobileDevice && hasKiosk && menu.layout == 'frydate' && !isSearchKiosk ? 'fixed right-0 left-0 w-80 h-screen w-88': (isSearchKiosk ? 'sticky w-full flex justify-center' : '')]"
          :style="
          menu.layout == 'frydate' && !isSearchKiosk ? leftCategoryNavigationBackground : ''
          ">
            <Header
              ref="Header"
              @category-changed="categoryChanged"
              :class="[
                'hidden md:min-w-72 md:w-fit mr-2 h-full',
                menu.is_kiosk_horiz_categ && hasKiosk
                  ? 'hidden'
                  : 'block md:block',
                menu.layout == 'frydate' ? 'pl-5 h-full pr-5' : ''
              ]"
            />
          </div>
          <!-- <Header
            v-if="hasKiosk"
            :class="[
              'hidden md:w-72',
              menu.is_kiosk_horiz_categ ||menu.desktop_kiosk_left_bar
                ? 'hidden'
                : 'block md:block',
            ]"
          /> -->
          <!-- For Frydate it was required to not scroll the sidebar but only the content so the classes are applied - only fridate condition -->
          <div
            :ref="!menu.desktop_kiosk_left_bar ? 'categoryScrollableDiv' : ''"
            @scroll="handleScroll"
            :class="[
              'md:flex md:flex-col md:items-center md:w-full h-full',
              !menu.is_kiosk_horiz_categ && !isMobileDevice && hasKiosk && menu.layout == 'frydate' && !isSearchKiosk ? 'ml-88 pb-20' : '',
              !menu.is_kiosk_horiz_categ && !isMobileDevice && hasKiosk && menu.layout == 'frydate' && isSearchKiosk? 'ml-0' : '',
              !hasKiosk && !menu.desktop_kiosk_left_bar && 'overflow-y-scroll',
              hasKiosk && !isMobileDevice && menu.layout == 'frydate' ? 'overflow-scroll' : 'overflow-scroll',
              hasKiosk && !isMobileDevice && isSearchKiosk && !menu.is_kiosk_horiz_categ? 'overflow-scroll ' : 'overflow-scroll',
              hasKiosk && !isMobileDevice && menu.layout == 'frydate' && isSearchKiosk ? 'pb-56' : '',
              cartItems.length && hasKiosk && !isSearchKiosk ? 'paddingBottomItems' : '',
              isSearchKiosk && !searchItemInput ? 'hidden' : '',
            ]"
          >
            <div
              v-if="!hasKiosk"
              :class="
                userAgent.device.type === 'desktop'
                  ? 'w-full h-full flex flex-col justify-between'
                  : '' + ' w-full h-full flex flex-col justify-between'
              "
            >
            <SubCategory
            v-if="!isUpselling"
                :class="[
                  ,
                  userAgent.device.type === 'desktop'
                    ? ''
                    : !menu.is_kiosk_horiz_categ&&'md:w-11/12 non-horizon',
                ]"
              />
              <Footer />
            </div>
            <div
              v-else
              class="md:flex md:flex-col md:items-center md:w-full"
            >
              <SubCategory :class="!menu.is_kiosk_horiz_categ &&'md:w-11/12 non-horizon'" 
              v-if="!isUpselling"/>
              <Footer />
            </div>
          </div>
        </div>
      </div>
      <!-- <Footer /> -->
    </div>
  </div>
</template>
<script>
import SubCategory from "../views/SubCategory";
import Category from "../views/Category";
import { mapGetters } from "vuex";
import Header from "../components/Header";
import lang from "../lang.js";
import Footer from "../components/Footer";
import TopNavigation from "../components/TopNaviation.vue";
export default {
  name: "Main",
  data() {
    return {
      lang: lang,
      menuDivsOffsetValue: [],
      newIndex: undefined,
      isScrolling: false,
      restaurantHeaderHeight: 0,
    };
  },
  components: { Category, SubCategory, Footer, Header, TopNavigation },
  computed: {
    ...mapGetters([
      "isSearchKiosk",
      "searchItemInput",
      "userAgent",
      "categoryId",
      "infiniteScroll",
      "isThemeLoading",
      "menu",
      "hasKiosk",
      'isMobileDevice',
      "menuCategories",
      "menuItems",
      "language",
      "isUpselling",
    ]),
    ...mapGetters("Theme", ["mainSubCategorysBackground","mainSectionTopRadius", "leftCategoryNavigationBackground","backgroundImage"]),
    ...mapGetters("Cart", ["cartItems"]),
  },
  watch: {
    menuItems() {
      this.$nextTick(() => {
        /** If not infinity scroll feature and menuItems/category change
         * scroll menu to top.
         */
        if (this.$refs.categoryScrollableDiv && !this.infiniteScroll)
          this.$refs.categoryScrollableDiv.scroll(0, 0);
      });
    },
    isThemeLoading(value) {
      if (!value) {
        this.getHeaderHeight();
      }
    }
  },

  methods: {
    /**
     * @param categoryId
     *
     * @returns void
     *
     * Change selected category and executes handleCarouselClick() method
     * in TopNavigation component and scrollSelectedCategoryIntoView() in Category component
     * to change active category. It will make a delay of 1 sec to change the category to prevent
     * changing menu category during scroll to selected menu category in Infinity scroll feature.
     *  */
    categoryChanged(categoryId) {
      let categoryHeaderElement = document.getElementById(
        "menu-group-item-" + categoryId
      );
      let menuCategory = this.menuCategories.find((el) => el.Id == categoryId);
      if (categoryHeaderElement) {
        this.$refs.categoryScrollableDiv.scroll(
          0,
          categoryHeaderElement.offsetTop
        );
        categoryHeaderElement.scrollIntoView({
        behavior: 'smooth'
        })
        this.$store.commit("updateSelectedMenuCategory", menuCategory);
        let newIndex = this.menuCategories.findIndex((e) => e.Id == categoryId);
        this.$refs.TopNavigation.handleCarouselClick(newIndex, false);
        this.$refs.Category.scrollSelectedCategoryIntoView();
        this.newIndex = newIndex;
        this.isScrolling = true;
        setTimeout(() => {
          this.isScrolling = false;
        }, 1000);
      }
    },
    /**
     * @param e scrollEvent
     * @returns void
     *
     * Handle scroll and change selected menu category based on in view ( visible on screen ) category or category Items.
     * If category changed then execute the methods that are responsible to change selected menu category like
     * changeActiveMenuCategory,handleCarouselClick and scrollSelectedCategoryIntoView
     *
     */
    handleScroll(e) {
      if (!this.infiniteScroll || this.isScrolling) {
        return;
      }
      if (!this.menuDivsOffsetValue.length) {
        let elements = document.querySelectorAll("[id^=menu-group-item-]");
        elements.forEach((el) => {
          this.menuDivsOffsetValue.push({
            top: el.offsetTop,
            bottom: el.offsetTop + el.offsetHeight,
            menuId: el.id.split("-").reverse()[0],
          });
        });
      }
      let scrollVal = e.target.scrollTop;
      this.menuDivsOffsetValue.forEach((el) => {
        if (el.top <= scrollVal && scrollVal < el.bottom) {
          let newIndex = this.menuCategories.findIndex(
            (e) => e.Id == el.menuId
          );
          if (newIndex != this.newIndex) {
            this.$refs.Header.changeActiveMenuCategory(el.menuId);
            this.$refs.TopNavigation.handleCarouselClick(newIndex, false);
            this.$refs.Category.scrollSelectedCategoryIntoView();
            this.newIndex = newIndex;
          }
        }
      });
    },

    /**
     * Fetch The Menus.
     *
     * @return void
     */
    getMenus() {
      if (this.hasKiosk) {
        this.$store
          .dispatch("GET_MENU_ITEMS")
          .then((response) => {
            /**
             * Checking if theme doesn't exists on the local storage then
             * storing the theme and reloading the page again to reflect the
             * theme in all the part of the website.
             */
            if (localStorage.getItem("theme") == null) {
              if (response.data.Menu.design) {
                this.$store.commit(
                  "setCurrentTheme",
                  response.data.Menu.design
                );
                location.reload();
              }
            }
            /**
             * If User has changed the theme then it will update the theme and
             * reload the page to reflect all part of the website.
             */
            if (localStorage.getItem("theme") != response.data.Menu.design) {
              this.$store.commit("setCurrentTheme", response.data.Menu.design);
              location.reload();
            }

            this.buttonSpinner = false;
          })
          .catch((error) => {
            this.buttonSpinner = false;
            if (error.response.status == 404) {
              this.errorMessage = "Please enter valid Menu Code";
            }
          });
      } else {
        this.buttonSpinner = false;
      }
    },
    getHeaderHeight() { 
    this.$nextTick(() => {
      this.restaurantHeaderHeight = this.$refs.categoryScrollableDiv?.getBoundingClientRect()?.top ||0;
    });

    },
    getAllMenus() {
      if (this.$route.params.categoryId) {
        this.categoryChanged(this.$route.params.categoryId);
      }
      this.buttonSpinner = false;

    },
  },
  mounted() {
     if (this.categoryId) {
      this.categoryChanged(this.categoryId)
    }
    this.getHeaderHeight();
    /**
     * If the link has the MenuHash it will get the Menu Hash details.
     *
     * Else it will hide the page loader and update the `menuHasAvailable`
     * to false so that it can show up input field to ask user for menuHash.
     */
    if (this.$route.params.menuHash) {
      if (Object.keys(this.menu).length == 0) {
        this.$store.commit("updateMenuHash", this.$route.params.menuHash);
        if (this.hasKiosk) {
          this.getMenus();
        } else {
          this.$store.dispatch("GET_CORRECT_MENU_ITEMS").then((response) => {
            if (this.infiniteScroll) {
              // if (
              //   !Object.keys(this.menu).length &&
              //   !this.$store.getters.loadingItems
              // ) {
                this.getAllMenus(response);
              // }
            } else {
              this.getMenus(response);
            }
          });
        }
      }
    } else {
      this.$store.commit("stopPageLoading");
    }
  },
};
</script>

<style scoped>
/* .heighttest {
  height: 90vh;
} */

.paddingBottomItems {
  margin-bottom: 500px;
}
</style>
